import React, { useCallback, useEffect, useRef, useState } from "react";
import Glyph from "./Glyphs";

/**
 * The address is assembled at runtime instead of being written as one literal
 * string, so the served HTML and this bundle hold nothing a regex-based
 * harvester can match. Combined with the mailto carrying a pre-filled subject
 * and body, a click lands the sender in a composed email instead of a blank one.
 */
const PARTS = ["info", "ahsanusman", "com"];
export const EMAIL = `${PARTS[0]}@${PARTS[1]}.${PARTS[2]}`;

const SUBJECT = "Project enquiry";
const BODY = "Hi Ahsan,\n\nWhat I'm building:\nCurrent stage:\nTimeline:\n";

export const MAILTO = `mailto:${EMAIL}?subject=${encodeURIComponent(SUBJECT)}&body=${encodeURIComponent(BODY)}`;

export function CopyEmailButton() {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = useCallback(async () => {
    let ok = false;

    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(EMAIL);
        ok = true;
      } catch {
        ok = false;
      }
    }

    /* Permission denied or an older browser: fall back to a hidden field. */
    if (!ok) {
      try {
        const field = document.createElement("textarea");
        field.value = EMAIL;
        field.setAttribute("readonly", "");
        field.style.position = "fixed";
        field.style.top = "-1000px";
        field.style.opacity = "0";
        document.body.appendChild(field);
        field.select();
        ok = document.execCommand("copy");
        document.body.removeChild(field);
      } catch {
        ok = false;
      }
    }

    setCopied(ok);
    clearTimeout(timer.current);
    if (ok) {
      timer.current = setTimeout(() => setCopied(false), 2400);
    }
  }, []);

  return (
    <span className="emailrow__copyWrap">
      <button
        type="button"
        className="emailrow__copy"
        onClick={copy}
        aria-label="Copy email address"
        data-copied={copied ? "true" : undefined}
      >
        <Glyph name={copied ? "check" : "copy"} />
      </button>
      <span className="emailrow__feedback" role="status" aria-live="polite">
        {copied ? "Copied" : null}
      </span>
    </span>
  );
}
